import gql from 'graphql-tag';

import publicAccountFragment from '../fragments/publicAccountFragment';

export const queryPublicAccount = gql`
  query account($id: DokkioID) {
    account(id: $id) {
      ...publicAccountFragment
    }
  }
  ${publicAccountFragment}
`;
export default queryPublicAccount;
